import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectGroup } from 'src/app/project/shared/interfaces/project-group.interface';
import { AlarmData } from 'src/app/project/shared/services/camera-alarm.service';
import { GroupService } from 'src/app/project/shared/services/group.service';

@Component({
  selector: 'avs-camera-alarm-pop-up',
  standalone: false,
  templateUrl: './camera-alarm-pop-up.component.html',
  styleUrl: './camera-alarm-pop-up.component.css'
})
export class CameraAlarmPopUpComponent implements OnInit {

  alarm?: AlarmData;
  groupName?: string;
  aktiveGroup?: ProjectGroup
  constructor(public dialogRef: MatDialogRef<CameraAlarmPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlarmData, private groupService: GroupService) { }

  ngOnInit(): void {
    this.alarm = this.data;
    this.groupService.getProjectGroup(this.data.groupId).subscribe(group => {
      if (group) {
        this.groupName = group.name;
        this.aktiveGroup = group;
      }
    });
  }

  onIgnore() {
    this.dialogRef.close({ action: 'IGNORE' });
  }

  onStream() {
/*     console.log('Stream clicked');
 */    this.dialogRef.close({ action: 'STREAM', stationGuid: this.data.guid, groupId: this.data.groupId, projectId: this.data.projectId });
  }

  onAufnahmenClicked() {
/*     console.log('Aufnahmen clicked');
 */    this.dialogRef.close({ action: 'RECORDINGS', stationGuid: this.data.guid, groupId: this.data.groupId, projectId: this.data.projectId });
  }
}
